/*!
  Almay Scripts
*/

(function(){
  // Almay brand-specific navigation functionality
  function almayNav() {
    if (theme.settings.brand_skin === 'almay') {
      // Get the Almay logo SVG element
      const almayLogos = document.querySelectorAll('#almay-logo');

      // Get all menu triggers
      const menuTriggers = document.querySelectorAll('.site-nav__link');

      // Get the header element
      const header = document.querySelector('.site-header');

      // Store the original logo color
      let originalLogoColor = '#ef4a81';

      if (window.SDG.data.collectionColor) {
        originalLogoColor = window.SDG.data.collectionColor;
      }

      menuTriggers.forEach(trigger => {
        trigger.addEventListener('mouseenter', function() {
          // Get the color from data attribute
          const menuColor = this.dataset.menuColor || originalLogoColor;

          // Remove active class from all triggers
          menuTriggers.forEach(t => t.classList.remove('hover-active'));

          // Add active class to current trigger
          this.classList.add('hover-active');

          // Get the position and width of the menu item
          const rect = this.getBoundingClientRect();
          const headerRect = header.getBoundingClientRect();

          // Set custom properties for the CSS to use
          header.style.setProperty('--menu-item-left', `${rect.left - headerRect.left}px`);
          header.style.setProperty('--menu-item-width', `${rect.width}px`);
          header.style.setProperty('--menu-border-color', menuColor);
          header.classList.add('menu-item-hovered');

          // Update the pseudo-element color
          document.documentElement.style.setProperty('--menu-border-color', menuColor);

          // Change the logo color
          if (almayLogos?.length) {
            almayLogos.forEach(logo => {
              logo.setAttribute('fill', menuColor);
              logo.style.fill = menuColor;
            });
          }
        });

        // Modified mouseleave handler - only reset if not hovering the megamenu
        trigger.addEventListener('mouseleave', function() {
          const parentListItem = this.closest('.site-nav__expanded-item.site-nav__item');

          setTimeout(() => {
            // Check if we're hovering either the trigger or its parent megamenu
            if (!document.querySelector('.js-megamenu-trigger:hover') &&
                !(parentListItem && parentListItem.matches(':hover'))) {
              header.classList.remove('menu-item-hovered');
              // Remove hover-active class from all triggers
              menuTriggers.forEach(t => t.classList.remove('hover-active'));
              if (almayLogos?.length) {
                almayLogos.forEach(logo => {
                  logo.setAttribute('fill', originalLogoColor);
                  logo.style.fill = originalLogoColor;
                });
              }
            }
          }, 50);
        });
      });

      // Add event listeners to the megamenu containers themselves
      const megamenus = document.querySelectorAll('.site-nav__expanded-item.site-nav__item');
      megamenus.forEach(menu => {
        const trigger = menu.querySelector('.js-megamenu-trigger');

        menu.addEventListener('mouseenter', function() {
          if (trigger) {
            // Simulate hover on the trigger
            trigger.dispatchEvent(new Event('mouseenter'));
          }
        });

        menu.addEventListener('mouseleave', function() {
          setTimeout(() => {
            if (!document.querySelector('.site-nav__expanded-item.site-nav__item:hover')) {
              header.classList.remove('menu-item-hovered');
              menuTriggers.forEach(t => t.classList.remove('hover-active'));
              if (almayLogos?.length) {
                almayLogos.forEach(logo => {
                  logo.setAttribute('fill', originalLogoColor);
                  logo.style.fill = originalLogoColor;
                });
              }
            }
          }, 50);
        });
      });

      // Reset when mouse leaves the entire navigation area
      const navigation = document.querySelector('.site-navigation');
      if (navigation) {
        navigation.addEventListener('mouseleave', function() {
          header.classList.remove('menu-item-hovered');
          // Remove hover-active class from all triggers
          menuTriggers.forEach(t => t.classList.remove('hover-active'));
          if (almayLogos?.length) {
            almayLogos.forEach(logo => {
              logo.setAttribute('fill', originalLogoColor);
              logo.style.fill = originalLogoColor;
            });
          }
        });
      }
    }
  }

  // Call the function to initialize
  almayNav();
})();
